import React from 'react';
import { useNavigate } from 'react-router-dom';
import PlayWizard from '../components/wizard/PlayWizard';

const NewPlayPage: React.FC = () => {
  const navigate = useNavigate();
  return <PlayWizard onClose={() => navigate('/plays')} />;
};

export default NewPlayPage;
